import { useState } from 'react';
import { Spacer, Stack } from '../ui/Layout';
import {
  SettingsCard,
  SettingsCardContent,
  SettingsCardHeader,
  SettingsSeparator,
} from './SettingsLayoutComponents';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Text from 'common/ui/Text';
import { useCurrentUser } from 'hooks/useCurrentUser';
import DownloadAuthenticator from './DownloadAuthenticator';
import MultiFactorAuthToggle from './MFAToggle';
import { telemetryContextFor } from 'modules/Apollo/types';

export const SecuritySettingsTab = ({ onClose }: { onClose: () => void }): React.ReactElement => {
  const { data: user } = useCurrentUser({ context: APOLLO_QUERY_CONTEXT });
  const me = user?.me;
  const [success, setSuccess] = useState<string | null>(null);
  const mfaEnabled = me?.securitySettings.multiFactorAuth.enabled ?? false;
  const mfaLinked = me?.securitySettings.multiFactorAuth.linked ?? false;
  const [authenticatorToken, setAuthenticatorToken] = useState(null);

  return (
    <SettingsCard>
      <SettingsCardHeader>
        <Stack alignY="center">
          <Text variant="display2">Login & Security</Text>
          <Spacer />
          <IconButton onClick={onClose} data-testid="security-tab-close" size="large">
            <Close />
          </IconButton>
        </Stack>
      </SettingsCardHeader>
      <SettingsCardContent>
        <Text variant="display1" display="block" gutterBottom="small">
          Multi-factor Authentication
        </Text>
        <MultiFactorAuthToggle
          multiFactorAuthEnabled={mfaEnabled}
          multiFactorAuthLinked={mfaLinked}
          setAuthenticatorToken={setAuthenticatorToken}
          authenticatorToken={authenticatorToken}
          setSuccess={setSuccess}
        />
        {success != null && (
          <span>
            <Text color="green4" data-testid="linked-success">
              {success}
            </Text>
          </span>
        )}
        {!mfaLinked && mfaEnabled && authenticatorToken && (
          <DownloadAuthenticator onSuccess={setSuccess} authenticatorToken={authenticatorToken} />
        )}
        <SettingsSeparator />
      </SettingsCardContent>
    </SettingsCard>
  );
};

SecuritySettingsTab.displayName = 'SecuritySettingsTab';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(SecuritySettingsTab);
